import { useMemo } from "react";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryShortcuts from "@/pages/home/components/CategoryShortcuts";
import LatestNews from "@/pages/home/components/LatestNews";
import HotRecommendations from "@/pages/home/components/HotRecommendations";
import StarHighlights from "@/pages/home/components/StarHighlights";
import SiteIntro from "@/pages/home/components/SiteIntro";
import HotTags from "@/pages/home/components/HotTags";
import RankList from "@/pages/home/components/RankList";
import { useScrollToTop } from "@/hooks/useScrollToTop";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import {
  getAllArticles,
  getFeaturedArticles,
  getHotArticles,
  getArticlesByCategory,
  sortArticles,
} from "@/lib/articles";
import { hotTags } from "@/mocks/articles";

export default function Home() {
  useScrollToTop();
  useDocumentMeta(
    "蜜桃33 - 最新娱乐资讯与多元内容平台",
    "蜜桃33为您提供最新的娱乐资讯、影视推荐及多元娱乐内容，涵盖电影、电视剧和明星动态，满足您的娱乐需求。",
  );

  const featured = useMemo(() => getFeaturedArticles(4), []);
  const latest = useMemo(() => sortArticles(getAllArticles(), "latest").slice(0, 6), []);
  const hotRecommend = useMemo(
    () => sortArticles(getArticlesByCategory("recommendations"), "hot").slice(0, 4),
    [],
  );
  const starNews = useMemo(
    () => sortArticles(getArticlesByCategory("stars"), "latest").slice(0, 4),
    [],
  );
  const ranking = useMemo(() => getHotArticles(5), []);

  return (
    <div className="w-full pb-16">
      <div className="mx-auto w-full max-w-[1200px] px-4 pt-6 md:px-6">
        <HeroCarousel articles={featured} />
        <div className="mt-6 animate-fade-up">
          <CategoryShortcuts />
        </div>
      </div>

      <div className="mx-auto mt-12 w-full max-w-[1200px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <LatestNews articles={latest} />
          </div>
          <div className="flex flex-col gap-6 lg:col-span-1">
            <RankList articles={ranking} />
            <HotTags tags={hotTags} />
          </div>
        </div>
      </div>

      <div className="mx-auto mt-14 w-full max-w-[1200px] px-4 md:px-6">
        <HotRecommendations articles={hotRecommend} />
      </div>

      <div className="mx-auto mt-14 w-full max-w-[1200px] px-4 md:px-6">
        <StarHighlights articles={starNews} />
      </div>

      <div className="mx-auto mt-14 w-full max-w-[1200px] px-4 md:px-6">
        <SiteIntro />
      </div>
    </div>
  );
}